import React, { useEffect, useMemo, useState } from "react";

import "./Infocustomer.css";
const ITEMS_PER_PAGE = 30;

const Infocustomer = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [deactivateMessage, setDeactivateMessage] = useState("");
  const [deactivateMessageType, setDeactivateMessageType] = useState("");
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [branchMode, setBranchMode] = useState("add");
  const [isSavingBranch, setIsSavingBranch] = useState(false);
  const [branchMessage, setBranchMessage] = useState("");
  const [branchMessageType, setBranchMessageType] = useState("");
  const [branchForm, setBranchForm] = useState({
    branchId: null,
    companyId: null,
    companyName: "",
    branchNo: "",
    branchName: "",
  });

  const [branchChangeConfirm, setBranchChangeConfirm] = useState(null);

  const [isChangingBranch, setIsChangingBranch] = useState(false);

  const [branches, setBranches] = useState([]);

  const [changingBranchCustomerId] =
    useState(null);

  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "asc",
  });

  const requestBranchChange = (customer, newBranchId) => {
    const branchId = Number(newBranchId);

    if (!branchId) {
      return;
    }

    if (Number(customer.customer_company_branch_id) === branchId) {
      return;
    }

    const selectedBranch = branches.find(
      (branch) => Number(branch.id) === branchId,
    );

    if (!selectedBranch) {
      return;
    }

    setBranchChangeConfirm({
      customerId: customer.id,

      customerName: customer.name || "-",

      oldBranchId: customer.customer_company_branch_id,

      oldBranchName: customer.BranchDisplay || "-",

      newBranchId: selectedBranch.id,

      newBranchName: `${selectedBranch.name}${
        selectedBranch.branch_no ? `(${selectedBranch.branch_no})` : ""
      }`,
    });
  };

  const confirmBranchChange = async () => {
    if (!branchChangeConfirm) {
      return;
    }

    try {
      setIsChangingBranch(true);

      const res = await fetch(
        `/api/customer/${branchChangeConfirm.customerId}/branch`,
        {
          method: "PATCH",

          credentials: "include",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            customer_company_branch_id: Number(branchChangeConfirm.newBranchId),
          }),
        },
      );

      const responseData = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(responseData?.error || "Failed to change branch");
      }

      await fetchData();

      setBranchChangeConfirm(null);
    } catch (err) {
      console.error("Change branch error:", err);

      alert(err.message || "ไม่สามารถเปลี่ยน Branch ได้");
    } finally {
      setIsChangingBranch(false);
    }
  };

  const cancelBranchChange = () => {
    if (isChangingBranch) {
      return;
    }

    setBranchChangeConfirm(null);
  };

  useEffect(() => {
    fetchData();
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const res = await fetch(`/api/customer/branches`, {
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const json = await res.json();

      setBranches(Array.isArray(json) ? json : []);
    } catch (err) {
      console.error("Fetch branches error:", err);

      setBranches([]);
    }
  };

  const fetchData = async () => {
    try {
      const res = await fetch("/api/customer", {
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const json = await res.json();

      setData(Array.isArray(json) ? json : []);
    } catch (err) {
      console.error("Error fetching data:", err);

      setData([]);
    }
  };

  const deactivateCustomer = (id) => {
    setSelectedCustomerId(id);

    setDeactivateMessage("");
    setDeactivateMessageType("");

    setShowDeactivateConfirm(true);
  };

  const confirmDeactivateCustomer = async () => {
    if (!selectedCustomerId) {
      return;
    }

    setIsDeactivating(true);

    setDeactivateMessage("");
    setDeactivateMessageType("");

    try {
      const res = await fetch(
        `/api/customer/${selectedCustomerId}/deactivate`,
        {
          method: "PATCH",
          credentials: "include",
        },
      );

      const responseData = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(responseData?.error || "Deactivate failed");
      }

      setShowDeactivateConfirm(false);

      setSelectedCustomerId(null);

      setDeactivateMessage("Customer has been deactivated.");

      setDeactivateMessageType("success");

      await fetchData();

      setTimeout(() => {
        setDeactivateMessage("");
        setDeactivateMessageType("");
      }, 3000);
    } catch (err) {
      console.error("Deactivate failed:", err);

      setDeactivateMessage(err.message || "Failed to deactivate customer.");

      setDeactivateMessageType("error");
    } finally {
      setIsDeactivating(false);
    }
  };

  const cancelDeactivateCustomer = () => {
    setShowDeactivateConfirm(false);

    setSelectedCustomerId(null);

    setDeactivateMessage("");
    setDeactivateMessageType("");
  };

  const openAddBranch = (companyId, companyName) => {
    if (!companyId) {
      return;
    }

    setBranchMode("add");

    setBranchForm({
      branchId: null,
      companyId,
      companyName: companyName || "",
      branchNo: "",
      branchName: "",
    });

    setBranchMessage("");
    setBranchMessageType("");

    setShowBranchModal(true);
  };

  const openEditBranch = (branchId, companyId, companyName) => {
    const selectedBranch = branches.find(
      (branch) =>
        Number(branch.id) === Number(branchId) &&
        Number(branch.customer_company_id) === Number(companyId),
    );

    if (!selectedBranch) {
      alert("ไม่พบ Branch ใน Company นี้");
      return;
    }

    setBranchMode("edit");

    setBranchForm({
      branchId: selectedBranch.id,
      companyId: Number(companyId),
      companyName: companyName || "",
      branchNo: selectedBranch.branch_no || "",
      branchName: selectedBranch.name || "",
    });

    setBranchMessage("");
    setBranchMessageType("");
    setShowBranchModal(true);
  };

  const closeBranchModal = () => {
    if (isSavingBranch) {
      return;
    }

    setShowBranchModal(false);

    setBranchMessage("");
    setBranchMessageType("");

    setBranchForm({
      branchId: null,
      companyId: null,
      companyName: "",
      branchNo: "",
      branchName: "",
    });
  };

  const handleBranchInputChange = (event) => {
    const { name, value } = event.target;

    setBranchForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const saveBranch = async (event) => {
    event.preventDefault();

    const branchNo = branchForm.branchNo.trim();

    const branchName = branchForm.branchName.trim();

    if (!branchNo) {
      setBranchMessage("กรุณากรอกรหัส Branch");

      setBranchMessageType("error");

      return;
    }

    if (!branchName) {
      setBranchMessage("กรุณากรอกชื่อ Branch");

      setBranchMessageType("error");

      return;
    }

    setIsSavingBranch(true);

    setBranchMessage("");
    setBranchMessageType("");

    try {
      let url = `/api/customer/branch`;

      let method = "POST";

      let body = {
        customer_company_id: branchForm.companyId,

        branch_no: branchNo,

        name: branchName,
      };
      if (branchMode === "edit") {
        url =
          `/api/customer/branch/` + branchForm.branchId;

        method = "PATCH";

        body = {
          customer_company_id: Number(branchForm.companyId),

          name: branchName,
        };
      }

      const res = await fetch(url, {
        method,

        credentials: "include",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(body),
      });

      const responseData = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(responseData?.error || "Unable to save branch");
      }

      setBranchMessage(
        branchMode === "add" ? "เพิ่ม Branch สำเร็จ" : "แก้ไข Branch สำเร็จ",
      );

      setBranchMessageType("success");
      await Promise.all([
        fetchData(),
        fetchBranches(),
      ])

      setTimeout(() => {
        closeBranchModal();
      }, 800);
    } catch (err) {
      console.error("Save branch failed:", err);

      setBranchMessage(err.message || "ไม่สามารถบันทึก Branch ได้");

      setBranchMessageType("error");
    } finally {
      setIsSavingBranch(false);
    }
  };

  const handleSort = (key) => {
    setSortConfig((previous) => {
      if (previous.key === key) {
        return {
          key,

          direction: previous.direction === "asc" ? "desc" : "asc",
        };
      }

      return {
        key,
        direction: "asc",
      };
    });

    setCurrentPage(1);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return "";
    }

    return sortConfig.direction === "asc" ? " ▲" : " ▼";
  };

  const sortedData = useMemo(() => {
    return [...data].sort((firstItem, secondItem) => {
      const firstCompany = firstItem.CompanyName || "";

      const secondCompany = secondItem.CompanyName || "";
      const companyCompare = firstCompany.localeCompare(
        secondCompany,
        undefined,
        {
          numeric: true,
          sensitivity: "base",
        },
      );

      if (companyCompare !== 0) {
        return companyCompare;
      }

      if (!sortConfig.key) {
        return 0;
      }

      const firstValue = firstItem?.[sortConfig.key];

      const secondValue = secondItem?.[sortConfig.key];

      const firstIsEmpty =
        firstValue === null ||
        firstValue === undefined ||
        String(firstValue).trim() === "";

      const secondIsEmpty =
        secondValue === null ||
        secondValue === undefined ||
        String(secondValue).trim() === "";

      if (firstIsEmpty && secondIsEmpty) {
        return 0;
      }

      if (firstIsEmpty) {
        return 1;
      }

      if (secondIsEmpty) {
        return -1;
      }

      const compareResult = String(firstValue).localeCompare(
        String(secondValue),
        undefined,
        {
          numeric: true,
          sensitivity: "base",
        },
      );

      return sortConfig.direction === "asc" ? compareResult : -compareResult;
    });
  }, [data, sortConfig]);

  const totalPages = Math.ceil(sortedData.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  const paginatedData = sortedData.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  /*
  |--------------------------------------------------------------------------
  | Group Company สำหรับแสดงผล
  |--------------------------------------------------------------------------
  */

  const groupedData = useMemo(() => {
    const groups = [];

    paginatedData.forEach((customer) => {
      const key = customer.CompanyId ?? "no-company";

      let group = groups.find((item) => item.key === key);

      if (!group) {
        group = {
          key,

          companyId: customer.CompanyId,

          companyName: customer.CompanyName || "No Company",

          customers: [],
        };

        groups.push(group);
      }

      group.customers.push(customer);
    });

    return groups;
  }, [paginatedData]);

  return (
    <div className="infocustomer-container">
      <h1 className="cus-info-title">Customer Information</h1>

      <p className="customer-total">ทั้งหมด {data.length} รายการ</p>
      <p className="sm-des-infopage">
        *หลังจาก Add branch กรุณารีเฟรชหน้าจอ1ครั้ง
      </p>
      <div className="infocustomer-table-frame">
        <table className="infocustomer-table">
          <thead>
            <tr>
              <th onClick={() => handleSort("email")}>
                Email
                {getSortIcon("email")}
              </th>

              <th onClick={() => handleSort("name")}>
                Name
                {getSortIcon("name")}
              </th>

              <th>Company</th>

              <th>Branch</th>

              <th onClick={() => handleSort("position")}>
                Position
                {getSortIcon("position")}
              </th>

              <th onClick={() => handleSort("phone")}>
                Phone
                {getSortIcon("phone")}
              </th>

              <th onClick={() => handleSort("address")}>
                Address
                {getSortIcon("address")}
              </th>

              <th onClick={() => handleSort("timezone_offset")}>
                Timezone
                {getSortIcon("timezone_offset")}
              </th>

              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {groupedData.length > 0 ? (
              groupedData.map((group) => (
                <React.Fragment key={group.key}>
                  {/* Company Header */}

                  <tr className="company-group-row">
                    <td colSpan="9">
                      <div className="company-group-content">
                        <div>
                          <strong>{group.companyName}</strong>

                          <span className="company-customer-count">
                            {group.customers.length} customers
                          </span>
                        </div>

                        {group.companyId && (
                          <div className="company-branch-actions">
                            <select
                              className="branch-edit-select"
                              defaultValue=""
                              onChange={(event) => {
                                const branchId = event.target.value;

                                if (!branchId) {
                                  return;
                                }

                                openEditBranch(
                                  branchId,
                                  group.companyId,
                                  group.companyName,
                                );

                                // reset dropdown หลังเลือก
                                event.target.value = "";
                              }}
                            >
                              <option value="">Edit Branch...</option>

                              {branches
                                .filter(
                                  (branch) =>
                                    Number(branch.customer_company_id) ===
                                    Number(group.companyId),
                                )
                                .map((branch) => (
                                  <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                    {branch.branch_no
                                      ? ` (${branch.branch_no})`
                                      : ""}
                                  </option>
                                ))}
                            </select>

                            <button
                              type="button"
                              className="branch-add-button"
                              onClick={() =>
                                openAddBranch(
                                  group.companyId,
                                  group.companyName,
                                )
                              }
                            >
                              + Add Branch
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>

                  {group.customers.map((item) => (
                    <tr
                      key={item.id}
                      className={item.is_active === 0 ? "inactive-row" : ""}
                    >
                      <td>{item.email}</td>

                      <td>{item.name}</td>

                      <td>{item.CompanyName}</td>

                      <td>
                        {(() => {
                          const currentBranchId =
                            item.customer_company_branch_id;

                          const currentBranch = branches.find(
                            (branch) =>
                              Number(branch.id) === Number(currentBranchId),
                          );

                          const companyBranches = branches.filter(
                            (branch) =>
                              Number(branch.customer_company_id) ===
                              Number(item.CompanyId),
                          );

                          return (
                            <>
                              <select
                                className="branch-select"
                                value={currentBranchId ?? ""}
                                disabled={isChangingBranch}
                                onChange={(event) =>
                                  requestBranchChange(item, event.target.value)
                                }
                              >
                                {currentBranchId == null && (
                                  <option value="">
                                    ยังไม่ได้กำหนด Branch (ปัจจุบัน)
                                  </option>
                                )}

                                {/* Branch ปัจจุบัน */}
                                {currentBranch && (
                                  <option value={currentBranch.id}>
                                    {currentBranch.name}
                                    {currentBranch.branch_no
                                      ? `(${currentBranch.branch_no})`
                                      : ""}
                                    {" - ปัจจุบัน"}
                                  </option>
                                )}

                                {/* Branch อื่นใน Company เดียวกัน */}
                                {companyBranches
                                  .filter(
                                    (branch) =>
                                      Number(branch.id) !==
                                      Number(currentBranchId),
                                  )
                                  .map((branch) => (
                                    <option key={branch.id} value={branch.id}>
                                      {branch.name}
                                      {branch.branch_no
                                        ? `(${branch.branch_no})`
                                        : ""}
                                    </option>
                                  ))}
                              </select>

                              {changingBranchCustomerId === item.id && (
                                <span className="branch-saving">Saving...</span>
                              )}
                            </>
                          );
                        })()}
                      </td>
                      <td>{item.position}</td>

                      <td>{item.phone}</td>

                      <td>{item.address}</td>

                      <td>{item.timezone_offset}</td>

                      <td>
                        <button
                          className="infocustomer-delete-button"
                          disabled={item.is_active === 0}
                          onClick={() => {
                            if (item.is_active === 1) {
                              deactivateCustomer(item.id);
                            }
                          }}
                        >
                          {item.is_active === 1 ? "Deactivate" : "Disabled"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="9">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="ticket-pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from(
            {
              length: totalPages,
            },
            (_, index) => {
              const page = index + 1;

              return (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={currentPage === page ? "active-page" : ""}
                >
                  {page}
                </button>
              );
            },
          )}

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {showBranchModal && (
        <div className="customer-modal-overlay">
          <div className="customer-confirm-modal branch-modal">
            <h3>{branchMode === "add" ? "Add Branch" : "Edit Branch"}</h3>

            <p className="branch-company-name">
              Company: <strong>{branchForm.companyName}</strong>
            </p>

            <form onSubmit={saveBranch}>
              <div className="branch-form-group">
                <label>Branch Code</label>

                <input
                  type="text"
                  name="branchNo"
                  value={branchForm.branchNo}
                  onChange={handleBranchInputChange}
                  placeholder="เช่น 00001"
                  disabled={isSavingBranch || branchMode === "edit"}
                />
              </div>

              <div className="branch-form-group">
                <label>Branch Name</label>

                <input
                  type="text"
                  name="branchName"
                  value={branchForm.branchName}
                  onChange={handleBranchInputChange}
                  placeholder="เช่น สำนักงานใหญ่"
                  disabled={isSavingBranch}
                />
              </div>

              {branchMessage && (
                <div className={`customer-popup-message ${branchMessageType}`}>
                  {branchMessage}
                </div>
              )}

              <div className="customer-confirm-actions">
                <button
                  type="submit"
                  className="branch-save-button"
                  disabled={isSavingBranch}
                >
                  {isSavingBranch ? "กำลังบันทึก..." : "Save"}
                </button>

                <button
                  type="button"
                  className="customer-confirm-cancel-btn"
                  onClick={closeBranchModal}
                  disabled={isSavingBranch}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeactivateConfirm && (
        <div className="customer-modal-overlay">
          <div className="customer-confirm-modal">
            <h3>ยืนยันการปิดใช้งาน</h3>

            <p>ต้องการปิดการใช้งานลูกค้ารายนี้ใช่หรือไม่?</p>

            {deactivateMessage && (
              <div
                className={`customer-popup-message ${deactivateMessageType}`}
              >
                {deactivateMessage}
              </div>
            )}

            <div className="customer-confirm-actions">
              <button
                type="button"
                className="customer-confirm-danger-btn"
                onClick={confirmDeactivateCustomer}
                disabled={isDeactivating}
              >
                {isDeactivating ? "กำลังดำเนินการ..." : "ยืนยัน"}
              </button>

              <button
                type="button"
                className="customer-confirm-cancel-btn"
                onClick={cancelDeactivateCustomer}
                disabled={isDeactivating}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      )}
      {deactivateMessage && !showDeactivateConfirm && (
        <div className="customer-toast-wrapper">
          <div className={`customer-toast-message ${deactivateMessageType}`}>
            {deactivateMessage}
          </div>
        </div>
      )}

      {branchChangeConfirm && (
        <div className="customer-modal-overlay">
          <div className="customer-confirm-modal branch-change-modal">
            <h3>ยืนยันการเปลี่ยน Branch</h3>

            <p className="branch-change-customer">
              Customer: <strong>{branchChangeConfirm.customerName}</strong>
            </p>

            <div className="branch-change-detail">
              <div className="branch-change-row">
                <span className="branch-change-label">Branch เดิม</span>

                <span className="branch-change-old">
                  {branchChangeConfirm.oldBranchName}
                </span>
              </div>
              <div className="branch-change-row">
                <span className="branch-change-label">Branch ใหม่</span>

                <span className="branch-change-new">
                  {branchChangeConfirm.newBranchName}
                </span>
              </div>
            </div>

            <p className="branch-change-question">
              ต้องการเปลี่ยน Branch ของ Customer รายนี้ใช่หรือไม่?
            </p>

            <div className="customer-confirm-actions">
              <button
                type="button"
                className="branch-confirm-button"
                onClick={confirmBranchChange}
                disabled={isChangingBranch}
              >
                {isChangingBranch ? "กำลังบันทึก..." : "ยืนยัน"}
              </button>

              <button
                type="button"
                className="customer-confirm-cancel-btn"
                onClick={cancelBranchChange}
                disabled={isChangingBranch}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Infocustomer;
